import React, {useState, useEffect} from 'react';
import imgSrc from "../images/default-video.png";
import axios from "axios";
import ReactJWPlayer from 'react-jw-player';

export default function ThumbnailVideo(props) {
    const [imgUrl, setImgUrl] = useState(imgSrc);

    useEffect(() => {
        if (props.item.fileUrl.includes('vimeo')) {
            const id = props.item.fileUrl.split('/').pop();
            (async () => {
                await axios.get(`https://vimeo.com/api/v2/video/${id}.json`)
                    .then(resp => {
                        if (resp.status === 200) {
                            const data = resp.data;
                            setImgUrl(data[0].thumbnail_large);
                        }
                    });
            })();
        } else {
            // var canvas = document.getElementById('canvas');
            // var video = document.getElementById('video');
            // canvas.getContext('2d').drawImage(video, 0, 0, 100, 80);
        }
    }, []);

    const handlePlay = e => {
        e.preventDefault();
        if (props.setPlaying) {
            props.setPlaying(props.item);
        }
    }

    return (
        <img
            key={props.item._id}
            src={props.item.thumbnailUrl || props.item.fileUrl}
            className={`video-thumbnail ${props.item._id}`}
            title={props.setPlaying && "Click to see this image."}
            onClick={handlePlay}
        />
        // <div onClick={handlePlay}>
        // <ReactJWPlayer
        //     className={`video-thumbnail ${props.item._id}`}
        //     playerId={props.item._id.toString()}
        //     playerScript='https://cdn.jwplayer.com/libraries/s7lNp89j.js'
        //     file={props.item.fileUrl}
        //     image={`https://images.pexels.com/photos/414171/pexels-photo-414171.jpeg?auto=compress&cs=tinysrgb&dpr=1&fit=crop&h=200&w=280`}
        // />
        // </div>
        // <video id="video" className={`video-thumbnail ${props.item._id}`} onClick={handlePlay}>
        //     <source src={props.item.fileUrl} type="video/mp4" />
        // </video>
    );
}